import { Dispatch, SetStateAction } from "react"
import { graphql } from "react-relay"
import { PatientTable } from "@/modules/patients/patient-list/patient-table"
import { PatientSearchItem } from "@/modules/patients/patient-list/types/PatientSearchItem"

export const patientSearchableTableFragment = graphql`
  fragment patientSearchableTable on PatientSearchResult {
    patientId
    country
    firstName
    lastName
    birthDate
    displayId
    phoneNumber
    city
    street
    postalCode
    gender
    compulsoryOrganisationName
    compulsoryHealthInsuranceCardNumber
    compulsoryPolicyNumber
    compulsoryInsureeNumber
    supplementary1OrganisationName
    supplementary1HealthInsuranceCardNumber
    supplementary1PolicyNumber
    supplementary1InsureeNumber
    supplementary2OrganisationName
    supplementary2HealthInsuranceCardNumber
    supplementary2PolicyNumber
    supplementary2InsureeNumber
    supplementary3OrganisationName
    supplementary3HealthInsuranceCardNumber
    supplementary3PolicyNumber
    supplementary3InsureeNumber
    isPotentialDuplicate
    lastContactAt
    highlights {
      key
      value
    }
    searchScore
  }
`

interface PatientTableProps {
  keyword: string
  data: PatientSearchItem[]
  hasFilterChanged: boolean
  totalCount: number
  isHealthInsuranceCardNumberMissing: boolean
  endReached: () => void
  setPatientQuery: Dispatch<SetStateAction<string>>
  onPatientUpdated: () => void
}

const PatientSearchableTable = ({
  keyword,
  data,
  hasFilterChanged,
  totalCount,
  isHealthInsuranceCardNumberMissing,
  endReached,
  setPatientQuery,
  onPatientUpdated,
}: PatientTableProps) => {
  return (
    <PatientTable
      keyword={keyword}
      data={data}
      hasFilterChanged={hasFilterChanged}
      totalCount={totalCount}
      isHealthInsuranceCardNumberMissing={isHealthInsuranceCardNumberMissing}
      endReached={endReached}
      setPatientQuery={setPatientQuery}
      onPatientUpdated={onPatientUpdated}
    />
  )
}

export { PatientSearchableTable }
